import { type HTMLAttributes, type ReactNode } from 'react';
import { cn } from './cn';

export interface FormSectionProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

export function FormSection({
  title,
  description,
  actions,
  children,
  className,
  ...rest
}: FormSectionProps) {
  return (
    <section className={cn('ui-form-section', className)} {...rest}>
      <header className="ui-form-section__header">
        <div className="ui-form-section__heading">
          <h3 className="ui-form-section__title">{title}</h3>
          {description ? <p className="ui-form-section__description">{description}</p> : null}
        </div>
        {actions ? <div className="ui-form-section__actions">{actions}</div> : null}
      </header>
      <div className="ui-form-section__body">{children}</div>
    </section>
  );
}
